import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink as LinkHash } from 'react-router-hash-link';
import logoSubastas from '../../assets/subasta-logo.svg';

const Menu = () => {
  return (
    <div className="menu-desktop d-none d-md-block d-lg-block d-xl-block">
      <nav>
        <ul className="container mb-0">
          <li>
            <Link to="/">
              <img className="logo-secondary" src={logoSubastas} alt="menu-logo" />
            </Link>
          </li>

          <li className="not-link"><Link className="not-link" to="/subastas">Subastas</Link></li>
          <li><LinkHash to="/#subastas-recomendadas">Subastas recomendadas</LinkHash></li>
          <li><LinkHash to="/ganadores/#up">Ganadores</LinkHash></li>

        </ul>
      </nav>
    </div>
  );
};

export default Menu;
